import Vue from 'vue';

import {
    Button,
    Checkbox,
    CheckboxGroup,
    Icon,
    Calendar,
    Cascader,
    DatetimePicker,
    Picker,
    Field,
    Form,
    Toast,
    Popup,
    RadioGroup,
    Radio,
    IndexBar,
    IndexAnchor,
    Cell,
    CellGroup,
    Overlay
} from 'vant';

Vue.use(Button)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Icon)
    .use(Calendar)
    .use(DatetimePicker)
    .use(Cascader)
    .use(Picker)
    .use(Form)
    .use(Field)
    .use(Toast)
    .use(Popup)
    .use(Radio)
    .use(RadioGroup)
    .use(IndexBar)
    .use(IndexAnchor)
    .use(Cell)
    .use(CellGroup)
    .use(Overlay)
